import PropTypes from 'prop-types';
import { SeoLink } from 'dibs-seo/exports/SeoLink.tsx';

import { trackEvent } from 'dibs-tracking';

import styles from './ContemporaryLandingCategoriesModuleItem.scss';

const trackClick = item =>
    trackEvent({
        action: 'featured category',
        category: 'contemporary landing page interaction',
        label: `l3 clicked|${item.name}`,
    });

export const ContemporaryLandingCategoriesModuleItem = ({ item }) => {
    if (!item.imagePath) {
        return null;
    }

    return (
        <div className={`${styles.tile} colXs3`}>
            <SeoLink
                className={styles.item}
                linkData={item.linkData}
                onClick={() => trackClick(item)}
            >
                <img className={styles.image} src={item.imagePath} alt={item.name} />
                <p className={styles.title}>{item.name}</p>
            </SeoLink>
        </div>
    );
};

ContemporaryLandingCategoriesModuleItem.propTypes = {
    item: PropTypes.object,
};
